<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('wholesale.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('wholesale.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-9">
              <ProductList v-model="model" @calculate="onCalculate" />
              <ItemDetail
                v-model="model"
                :validate="errors"
                class="ts-mt-3"
                ref="itemDetail"
              />
            </div>
            <div class="col-md-3 ts-space-y-4">
              <CustomerSaleDate v-model="model" :validate="errors" />
              <Reference
                v-model="model"
                :validate="errors"
                @loading="value => (loading = value)"
                @clearInput="clearInput()"
              />
              <ExchangeRate v-model="model" :validate="errors" />
              <Payment v-model="model" :validate="errors" />
              <PaymentMethod
                v-model="model"
                :validate="errors"
                @loading="value => (loading = value)"
              />
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
              <ts-button
                :disabled="loading"
                @click.prevent="$router.push({ name: 'wholesale' })"
                >{{ $t('cancel') }}
              </ts-button>
              <ts-button
                :disabled="loading"
                @click.prevent="saveAddNew"
                outline
                color="primary"
                >{{ $t('savePrint') }}
              </ts-button>
              <ts-button
                :disabled="loading"
                @click.prevent="save"
                color="primary"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="loading" :src="src" />
    </a-modal>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import ItemDetail from './components/item-detail'
// import Reference from './components/reference'
import CustomerSaleDate from './components/customer-sale-date.vue'
import Reference from './components/references.vue'
import ExchangeRate from './components/exchange-rate.vue'
import Payment from './components/payment.vue'
import PaymentMethod from './components/payment-method.vue'
import ProductList from './components/product-list.vue'
export default {
  name: 'wholesaleCreate',
  components: {
    ItemDetail,
    Reference,
    CustomerSaleDate,
    ExchangeRate,
    Payment,
    PaymentMethod,
    ProductList
  },
  data () {
    return {
      show_pdf: false,
      src: null,
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        stock_out_date: moment().format('DD-MM-YYYY'),
        customer_id: null,
        sub_total: '',
        discount: 0,
        total_after_discount: 0,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: '',
        amount_deposit: 0,
        amount_paid: 0,
        amount_due: 0,
        next_payment_date: '',
        fx_rate: 0,
        remark: '',
        product_detail: [],
        quotation_id: null,
        contract_id: null,
        reference_no: null,
        seller_id: null,
        credit_day: 0,
        payment_method_id: 1,
        bank_name: null,
        account_number: null,
        account_name: null,
        action_button: false,
        contact_number: ''
      }
    }
  },
  computed: {
    ...mapState('wholesale/operation', ['customers', 'employees']),
    employeeList () {
      return this.employees.map(el => ({
        value: el.employee_id,
        label: el.employee_name_en
      }))
    },
    customerList () {
      return this.customers.map(el => ({
        value: el.customer_id,
        label: el.customer_name
      }))
    }
  },
  created () {
    this.model.fx_rate = parseFloat(
      this.$store.state.authUser.sys_setting.fx_rate
    )
    this.model.vat_rate = parseFloat(
      this.$store.state.authUser.sys_setting.vat_rate
    )
  },
  methods: {
    ...mapActions('wholesale/operation', ['store', 'getFormViewData']),
    save () {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'wholesale' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveAddNew () {
      this.loading = true
      this.show_pdf = true
      this.errors = new Errors()
      this.model.action_button = true
      this.store(this.model)
        .then(response => {
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput () {
      this.model.stock_out_date = moment().format('DD-MM-YYYY')
      this.model.customer_id = ''
      this.model.sub_total = ''
      this.model.discount = 0
      this.model.total_after_discount = 0
      this.model.vat_rate = 0
      this.model.vat_amount = 0
      this.model.grand_total = ''
      this.model.amount_deposit = 0
      this.model.amount_paid = 0
      this.model.amount_due = 0
      this.model.next_payment_date = ''
      this.model.fx_rate = 0
      this.model.remark = ''
      this.model.product_detail = []
      this.model.quotation_id = null
      this.model.contract_id = null
      this.model.reference_no = null
      this.model.seller_id = null
      this.model.credit_day = 0
      this.model.payment_method_id = 1
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
      this.model.contact_number = ''
    },
    onCalculate () {
      this.$refs.itemDetail.calculate()
    },
    fetchSetting () {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'setting'
        }
      })
        .then(response => {
          this.$store.commit(
            'wholesale/operation/SET_SETTING',
            response.data.setting
          )
        })
        .finally(() => (this.loading = false))
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchSetting()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('wholesale/operation/CLEAR_SETUP')
    next()
  }
}
</script>
